export default {
  methods: {
    hasPermission: function (permissions, value) {
      if(permissions){
        return permissions.find(permission => {
          return permission.name == value;
        }) ? true : false;
      }
      return false;
    }
  }
}
